<template>
  <div ref="container"></div>
</template>
<script>
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { reduxStore } from '@/store/store'

export default {
  inheritAttrs: false,
  props: {
    component: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      reactRoot: null,
    }
  },
  methods: {
    reRenderComponent() {
      this.reactRoot.render(
        createElement(Provider, { store: reduxStore }, createElement(this.component, this.$attrs)),
      )
    },
  },
  mounted() {
    this.reactRoot = createRoot(this.$refs.container)
    this.reRenderComponent()
  },
  destroyed() {
    this.reactRoot.unmount()
  },
  watch: {
    $attrs: {
      handler() {
        this.reRenderComponent()
      },
      deep: true,
    },
  },
}
</script>
